<template>
  <div class="my-4 flex items-center flex-row flex-wrap " v-if="crumbs && crumbs.length">
    <div
      v-for="(crumb, key) in crumbs"
      :key="key"
      class="text-sm font-semibold text-blue-500 common-breabcrumbs"
    >
      <div class="flex items-center flex-row">
        <router-link :to="{ name: crumb.name, params: crumb.params, hash: crumb.hash, query: crumb.query }">{{ crumb.label }}</router-link>
        <i class="material-icons text-gray-500" v-if="key !== crumbs.length - 1"
          >arrow_forward_ios</i
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: ["crumbs"]
};
</script>

<style>
.common-breabcrumbs {
  color: var(--common-breadcrumbs-color-active);
  font-size: var(--common-breabcrumbs-font-size);
  font-weight: var(--common-breabcrumbs-font-weight);
  line-height: var(--common-breabcrumbs-line-height);
}
.router-link-exact-active {
  color: var(--common-breadcrumbs-current-color);
}
</style>
